interface Props {
  hidden?: boolean;
}

const LoadingOverlay:React.FC<Props> = ({hidden}) => {
    return (
        <div
        hidden={hidden}
        style={{
            position:"fixed",
            width:'100%',
            height:'100%',
            zIndex:'1000',
            backgroundColor:'rgba(0,0,0,0.5)',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
        }}>
            <div className="center-all">
                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    )
}

export default LoadingOverlay